import React from 'react';
import styled from 'styled-components';
import Tabs, { TabsProps } from '@material-ui/core/Tabs';
import Tab, { TabProps } from '@material-ui/core/Tab';
import { colors } from '../../constants/colors';
import { fontFamily, fontSize } from '../../constants/text';

const SolvStyledTab = styled(
  ({
    animatedClassName,
    ...rest
  }: {
    animatedClassName?: string;
    defaultTextColor?: string;
    activeTextColor?: string;
  } & TabProps) => (
    <Tab
      classes={{ fullWidth: 'tab-full-width', wrapper: `tab-label ${animatedClassName || ''}` }}
      {...rest}
    />
  )
).withConfig({ componentId: 'sc-19zrcvd-0' })`
  && .tab-label {
    color: ${(props) => props.defaultTextColor ?? colors.squid};
    font-family: ${fontFamily.medium};
    font-size: ${fontSize.mediumSmall};
    text-transform: none;
    transition: color 200ms ease;
    display: inline-block;
  }

  && .selected {
    color: ${(props) => props.activeTextColor ?? colors.lightText};
  }

  && .fullWidth {
    flex-grow: 1;
  }
`;

const SolvTabs = styled((props) => (
  <Tabs
    classes={{ indicator: 'tab-indicator', root: 'tab-root', flexContainer: 'tab-flex-container' }}
    {...props}
  />
)).withConfig({ componentId: 'sc-19zrcvd-1' })`
  background-color: ${colors.white};

  && .tab-flex-container {
    box-shadow: inset 0 -1px 0 0 rgba(172, 172, 172, 0.5);
  }

  && .tab-indicator {
    height: 3px;
    background-color: ${colors.crunchBerry};
  }

  && .tab-root {
    background-color: ${colors.white};
  }
`;

/*
(ts-migrate) TODO: Migrate the remaining prop types
...Tabs.propTypes
*/
type Props = {
  className?: string;
  onChange: (...args: any[]) => any;
  value: any;
  children: any;
} & TabsProps;

const SimpleTabs = (props: Props) => {
  const { className, value, onChange, children, ...rest } = props;
  return (
    <SolvTabs className={className} onChange={onChange} value={value} {...rest}>
      {children}
    </SolvTabs>
  );
};

export { SimpleTabs as default, SolvStyledTab };
